import { client } from '@/services/api/axios.ts';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { EventRule } from '@/features/event-rules/schemas/event-rules.schema.ts';

export const usePatchEventRuleMutation = (
  {
    onSuccess,
  }: {
    onSuccess?: (data: object | undefined) => void;
  } = {
    onSuccess: () => {},
  }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      eventRule: Pick<EventRule, 'eventRuleId' | 'cooldownPeriod' | 'status'> & {
        forwardTo: string[] | undefined;
      }
    ) => {
      const { eventRuleId } = eventRule;

      return toast.promise(
        client.patch(`/events/rules/${eventRuleId}`, {
          cooldownPeriod: eventRule.cooldownPeriod,
          status: eventRule.status,
          forwardTo: eventRule.forwardTo,
        }),
        {
          loading: 'Updating event rule...',
          success: 'Successfully updated the event rule.',
          error: (_: unknown) => `Uh oh, there was an error with updating the event rule.`,
        }
      );
    },
    onSuccess: (data) => {
      if (data) {
        onSuccess?.(data);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['event-rules'] });
    },
  });
};
